import { Arrow } from "../atoms/Arrow";
import { Reveal } from "../atoms/Reveal";
import type { Copy } from "../lib/copy";
import { HeroAmbient } from "./HeroAmbient";
import { HeroVisual } from "./HeroVisual";

type HeroProps = {
  t: Copy;
};

/**
 * Centered editorial hero — pill tagline + big two-line title with a
 * Fraunces serif accent on the last word, sub-copy, CTAs, trust row, and
 * the Stratex-AI dashboard demo below. Sits above the PMS-logo strip.
 */
export function Hero({ t }: HeroProps) {
  return (
    <section id="top" className="hero">
      <HeroAmbient />

      <div className="hero-inner">
        <Reveal as="h1" className="hero-title">
          <span className="line">
            <span className="ink">{t.hero.title_a}</span>
          </span>
          <span className="line">
            <span className="ink">{t.hero.title_b}&nbsp;</span>
            <span className="serif-accent">{t.hero.title_c}</span>
          </span>
        </Reveal>

        <Reveal as="p" className="hero-sub" delay={180}>
          {t.hero.sub}
        </Reveal>

        <Reveal className="hero-ctas" delay={260}>
          <a href="#contact" className="btn btn-primary btn-lg">
            {t.hero.cta} <Arrow />
          </a>
          <a href="tel:+43720080785" className="btn btn-glass btn-lg">
            <span className="btn-play">▶</span> KOVA live testen
          </a>
        </Reveal>

        <Reveal className="hero-demo-wrap" delay={420}>
          <HeroVisual />
        </Reveal>
      </div>
    </section>
  );
}
